"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toObject = void 0;
var jsonStringify_1 = require("./jsonStringify");
// From https://github.com/GoogleChromeLabs/jsbi/issues/30
function toObject(object) {
    return JSON.parse((0, jsonStringify_1.jsonStringify)(object));
}
exports.toObject = toObject;
